module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBoldItalic.378a091b.ttf";